var ThirdPartyAuthorization = (function ($) {

    var auth = null;

	return function (successCallback) {

        $(function () {
            var settings = $('@thirdPartyAuthorizationSettings').data('settings');

            if (!settings || !!auth) return;

            auth = new Authorization({
                fid: settings.Fid,

                visaEnabled: settings.Enabled,
                visaApiKey: settings.APIKey,
                visaApiDomain: settings.APIUrl,
                providerType: settings.ProviderType,

                successCallback: successCallback
            });

            app = app || {};
            app.auth = auth;
        });
	};

})(jQuery);